import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthUser() {
    const navigate = useNavigate();

    // Function to get token from sessionStorage
    const getToken = () => {
        return sessionStorage.getItem("token") || null;
    };

    // Function to get user data from sessionStorage
    const getUser = () => {
        const userString = sessionStorage.getItem("user");
        return userString ? JSON.parse(userString) : null;
    };

    // States for token & user
    const [token, setToken] = useState(getToken());
    const [user, setUser] = useState(getUser());

    // Sync token changes from sessionStorage
    useEffect(() => {
        setToken(getToken());
        setUser(getUser());
    }, []);

    // Save token & user to sessionStorage
    const saveToken = (user, token) => {
        sessionStorage.setItem("token", token); // Store token as a string
        sessionStorage.setItem("user", JSON.stringify(user));

        setToken(token);
        setUser(user);
        navigate("/dashboard");
    };

    // Logout function
    const logout = () => {
        sessionStorage.clear();
        setToken(null);
        setUser(null);
        navigate("/login");
    };

    // Create Axios instance
    const http = axios.create({
        baseURL: "https://schoolcrud.teknij.com/school_backend/api",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
    });

    // Axios interceptor to attach Authorization token dynamically
    http.interceptors.request.use(
        (config) => {
            const authToken = getToken();
            if (authToken) {
                config.headers.Authorization = `Bearer ${authToken}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    return {
        setToken: saveToken,
        token,
        user,
        getToken,
        http,
        logout,
    };
}
